import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    breadcrumbsWrapper: 'relative w-full lg:mx-auto lg:max-w-360',
    breadcrumbs: 'absolute top-5 z-10 lg:top-8',
    image: 'w-full object-cover lg:h-full',
    title: 'lg:whitespace-pre-wrap',
    text: 'lg:whitespace-pre-wrap',
    description:
      'lg:text-m mt-2 text-xs leading-[1.4] font-light lg:mt-3 lg:leading-[1.5] lg:whitespace-pre-wrap',
    label: 'absolute -top-3 lg:relative lg:-top-2',
    button: 'inline-flex min-w-40 text-base',
    arrowPrev: 'left-10',
    arrowNext: 'right-10',
    carousel: '[--slide-size:100%]',
    banner:
      'bg-accent relative w-full after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0 max-md:after:bg-[#10060166]',
    wrapper: 'lg:mx-auto lg:max-w-360',
    middleContentWrapper: 'relative w-full lg:mx-auto lg:max-w-360',
    middleContent:
      'pointer-events-none absolute top-22 left-0 z-1 w-full lg:top-35.5',
    middleContentImage:
      'block h-auto w-full max-w-[var(--middle-content-max-width,100%)] lg:max-w-[var(--middle-content-max-width-lg,var(--middle-content-max-width,100%))]',
    content:
      'absolute bottom-[54px] left-0 z-1 md:max-w-[64%] lg:bottom-1/2 lg:max-w-full lg:translate-y-1/2',
    dots: 'absolute right-0 left-0 mx-auto w-full lg:max-w-360',
    arrowIcons: '',
    arrow: '',
    link: '',
    buttonWrapper: '',
    date: 'absolute top-6 left-6 z-10 flex items-center justify-center rounded-full bg-white px-[12px] py-[5.5px] text-[12px] leading-[140%] text-black lg:top-3 lg:left-3',
    dateExpire:
      'heading-xs-bold absolute top-6 left-6 z-10 flex items-center justify-center rounded-full bg-white px-3 py-1.5 whitespace-nowrap text-black uppercase'
  },
  variants: {
    type: {
      main: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 lg:left-35',
        image: 'h-full',
        banner: 'min-h-128 lg:h-200',
        title: 'text-[24px] md:text-[32px] lg:mb-4 lg:pt-0 lg:text-5xl',
        text: 'heading-m lg:heading-2xl mt-2',
        button: 'mt-6 min-w-50 lg:mt-12',
        content:
          'lg:max-w-inherit px-3 max-[1560px]:!px-10 max-lg:!px-3 lg:left-1/2 lg:!container lg:-translate-x-1/2 lg:!px-10',
        dots: 'bottom-5 left-[12px] w-[calc(100%-12px)] justify-start lg:bottom-8 lg:left-0 lg:justify-center',
        arrowPrev:
          'top-auto bottom-1/2 left-5 size-16 translate-y-1/2 hover:opacity-70 max-[1560px]:left-2 max-[1560px]:size-8',
        arrowNext:
          'top-auto right-5 bottom-1/2 size-16 translate-y-1/2 hover:opacity-70 max-[1560px]:right-2 max-[1560px]:size-8'
      },
      brand: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 lg:left-10',
        image: 'h-90',
        banner: 'h-90',
        title: 'text-[32px]',
        text: 'text-lg',
        button: 'mt-6',
        content:
          'absolute top-1/2 -translate-y-1/2 transform p-4 lg:ml-35 lg:max-w-[640px] lg:px-0',
        dots: 'bottom-6 pl-4 lg:pl-35',
        arrow: 'mt-4.5'
      },
      category: {
        breadcrumbs: 'left-5 lg:left-12',
        image: 'h-[500px] lg:h-150',
        banner: 'h-full lg:min-h-150',
        title: 'heading-2xl lg:heading-2xl-desk',
        text: 'mt-3 text-base leading-[1.4] font-light lg:mt-4 lg:text-lg',
        content: 'bottom-1/2 w-full max-w-[100%] translate-y-1/2 px-3 lg:px-24',
        buttonWrapper:
          'mt-7 grid w-1/2 w-[710px] max-w-full grid-cols-1 gap-3 lg:mt-8 lg:grid-cols-2'
      },
      product: {
        image: 'h-[237px] max-h-full lg:h-50 lg:min-h-100',
        banner: 'max-h-full',
        title: 'text-2xl font-medium tracking-[0.04em]',
        text: 'hidden tracking-[0.02em] lg:block',
        content:
          'right-3 bottom-8 left-3 translate-none lg:right-8 lg:bottom-8 lg:left-8 lg:translate-none lg:pr-[30%]',
        button:
          'right-0 bottom-0 mt-4 min-w-auto px-10 lg:absolute lg:mt-7 lg:mt-8 lg:max-w-[25%]'
      },
      blog: {
        image: 'h-full',
        banner: 'h-125 lg:h-135',
        title: 'text-xl md:text-2xl',
        text: 'mt-2 text-base leading-[1.4] font-light',
        content:
          'right-5 bottom-6 left-5 max-w-full translate-none lg:right-6 lg:bottom-6 lg:left-6 lg:translate-none',
        button: 'mt-6'
      },
      info: {
        image: 'h-full',
        banner: 'h-47 lg:h-74',
        title: 'heading-xl lg:heading-2xl z-1',
        content:
          'text-text-main-inversion top-6 right-5 bottom-4 left-5 flex max-w-full translate-none flex-col items-start justify-between lg:bottom-4 lg:translate-none',
        link: 'absolute -top-6 -right-5 -bottom-4 -left-5 flex items-end justify-start pb-4 pl-5 text-base hover:bg-[#10060133]',
        arrow:
          'text-text-main-inversion [&>path]:stroke-text-main-inversion -translate-y-[2px] -rotate-90'
      }
    },
    mode: {
      light: {
        title: 'text-text-main-inversion leading-[1.2]',
        subtitle: 'text-text-main-inversion',
        text: 'text-text-main-inversion',
        description: 'text-text-main-inversion',
        arrowIcons: '[&>path]:stroke-text-main-inversion'
      },
      dark: {
        title: 'text-text-main leading-[1.2]',
        subtitle: 'text-text-main',
        text: 'text-text-main',
        description: 'text-text-main',
        arrowIcons: '[&>path]:stroke-text-main',
        arrowPrev: 'text-text-main',
        arrowNext: 'text-text-main'
      }
    },
    alignText: {
      center: {},
      bottomLeft: {},
      centerLeft: {}
    },
    alignHeight: {
      auto: {}
    },
    bannerMain: {
      true: {
        image: 'h-62 lg:h-100',
        banner: 'h-full lg:min-h-100',
        breadcrumbs: 'left-3 max-lg:top-6 lg:left-10',
        middleContent: 'left-3 lg:left-10',
        content:
          'bottom-6 left-0 translate-y-0 lg:bottom-8 lg:left-10 lg:translate-y-0 lg:px-0',
        text: 'mt-1.5 text-[12px] font-light lg:mt-1.5 lg:text-[12px]',
        wrapper: 'relative'
      }
    }
  },
  compoundVariants: [
    {
      type: 'main',
      mode: 'dark',
      className: {
        title: 'text-text-main lg:text-text-main',
        text: 'text-text-main lg:text-text-main',
        description:
          'text-text-main lg:text-[18px] lg:leading-[1.5] lg:text-white'
      }
    },
    {
      type: 'category',
      alignText: 'center',
      className: {
        content:
          'bottom-1/2 left-1/2 max-w-[100%] -translate-x-1/2 translate-y-1/2 px-6 text-center lg:left-1/2 lg:ml-0 lg:-translate-x-1/2',
        buttonWrapper: 'mr-auto ml-auto justify-center'
      }
    },
    {
      type: 'category',
      alignText: 'bottomLeft',
      className: {
        content: 'bottom-8 translate-y-0 lg:bottom-13.5 lg:translate-y-0'
      }
    },
    {
      type: 'category',
      alignHeight: 'auto',
      className: {
        banner: 'l-0 b-0 r-0 static top-0 sm:absolute lg:min-h-0',
        image: 'h-[237px] sm:h-auto lg:h-full',
        carousel: 'static',
        content: 'max-xl:pr-0 lg:bottom-8 lg:px-8 xl:pr-[40%]',
        text: 'hidden leading-[1.2] sm:block lg:mt-1 lg:text-base',
        buttonWrapper:
          'absolute right-8 bottom-0 max-w-[35%] justify-end max-xl:static max-xl:max-w-full max-xl:justify-start max-sm:mt-4'
      }
    }
  ],
  defaultVariants: {
    type: 'main'
  }
});
